"use client";

import React from "react";
import { ComponentConfig } from "@puckeditor/core";
import { SiteFooter } from "@/components/SiteFooter";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";

export type SiteFooterBlockProps = Record<string, never>;

function ManagedSiteFooter() {
  const convexConfigured = Boolean(process.env.NEXT_PUBLIC_CONVEX_URL);
  const settings = useQuery(api.siteSettings.getPublic, convexConfigured ? {} : "skip");
  return <SiteFooter initialSettings={settings} />;
}

export const SiteFooterBlock: ComponentConfig<SiteFooterBlockProps> = {
  label: "Global Site Footer — edit in Settings",
  fields: {},
  defaultProps: {},
  render: () => <ManagedSiteFooter />,
};
